//#region src/schema/helpers/schema-cycle.ts
var e = Symbol("schema-ancestors"), t = (e) => {
	if (e && typeof e == "object") return "$ref" in e && typeof e.$ref == "string" ? e.$ref : e;
};
//#endregion
export { e as SCHEMA_ANCESTORS_SYMBOL, t as getCycleKey };

//# sourceMappingURL=schema-cycle.js.map